import { usePermissions } from '@/hooks/usePermissions'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { FiEdit2 } from 'react-icons/fi'
import { HiArrowLeft } from 'react-icons/hi'
import { useSelector } from 'react-redux'

import {
  Box,
  HStack,
  Icon,
  IconButton,
  Skeleton,
  Square,
  Text,
  VStack,
} from '@chakra-ui/react'

import { GuardTour } from '@/components/icons'
import { Button } from '@/components/ui'
import { selectEditMode } from '@/redux/ui/uiSlice'

interface TourPlanHeaderIProps {
  onEdit: () => void
  onClose: () => void
  isLoading: boolean
  name: string
  count: number
}

export const TourPlanHeader = ({
  isLoading,
  count,
  name,
  onEdit,
  onClose,
}: TourPlanHeaderIProps) => {
  const isEditMode = useSelector(selectEditMode)
  const { shouldEnableUpdateTourPlan } = usePermissions()
  return (
    <VStack alignItems='start' spacing='10px' w='full'>
      <HStack>
        <IconButton
          aria-label='go back to tour plans'
          borderRadius='5px'
          h='32px'
          icon={<Icon as={HiArrowLeft} color='#000' fontSize='18px' />}
          minWidth='30px'
          onClick={onClose}
          variant='ghost'
          w='32px'
        />
        <Square bgColor='#43BF9B' borderRadius='5px' size='32px'>
          <Icon as={GuardTour} color='#fff' />
        </Square>
        <VStack align='flex-start' flexShrink={1} isTruncated spacing='0'>
          <Skeleton isLoaded={!isLoading}>
            <Text
              color='#172B4D'
              fontSize='14px'
              fontWeight={500}
              isTruncated
              lineHeight='20px'
              w='full'
            >
              {name}
            </Text>
          </Skeleton>
          <Box w='full'>
            <Skeleton isLoaded={!isLoading}>
              <HStack>
                <Box>
                  <FaMapMarkerAlt color='#44546F' size={10} />
                </Box>
                <Text
                  color='#172B4D'
                  fontSize='12px'
                  fontWeight={400}
                  isTruncated
                  lineHeight='18px'
                >
                  {count}
                </Text>
              </HStack>
            </Skeleton>
          </Box>
        </VStack>
      </HStack>
      <Button
        isDisabled={!isEditMode || !shouldEnableUpdateTourPlan}
        isFullWidth
        justifyContent='flex-start'
        leftIcon={
          <Box mr='15px'>
            <FiEdit2 size={12} />
          </Box>
        }
        onClick={onEdit}
        variant='affirm'
      >
        Edit Tour Plan
      </Button>
    </VStack>
  )
}
